export enum AnalyticPilotPrecheckinEventPathList {
  Landing_page = 'Landing_page',
  Personal_information = 'Personal_information',
  Citizenship_residency = 'Citizenship_residency',
  Passport = 'Passport',
  Pilot_license = 'Pilot_license',
  Medical_certificate = 'Medical_certificate',
  Visa = 'Visa',
  Hotel_information = 'Hotel_information',
  Review = 'Review',
  Precheckin_done = 'Precheckin_done',
  Precheckin_error = 'Precheckin_error',
  Precheckin_survey = 'Precheckin_survey',
  Start_Home_Link = 'Home_Link',
  Start_Home_Card = 'Home_Card',
  Start_Training_Detail = 'Training_Detail',
  Edit = 'Edit',
  Summary = 'Summary',
  AccessPass = 'Access_Pass'
}
